import { MetricsEvent } from "./MetricsEvent";

// This is the interface that all metrics loggers implement
export interface IWebClientMetricsLogger {
  logEvent(evt: MetricsEvent): void;
}

// The separator used to generate unique metric description
export const uniqueKeySeparator = "_";

// Full metrics names. The key name should not include underscore '_'
const fullMetricsNameLookup: Record<string, string> = {
  EXEREM: "Execute Remote Command",
  PROREM: "Process Remote Command Response",
  EMLOAD: "Emscripten load",
  RNDRPT: "Render Panetable",
  RNDRRG: "Render Region",
  RTLPRC: "Runtime command local processing",
  EPLTTI: "Experienced Page Load Time",
  // Following metrics are used in EPT breakdown
  lsh: "Load Static Html",
  lvb: "Load ViewerBootstrap Module",
  lvql: "Load JS Modules",
  aep: "MetricsController Instantiated",
  ss: "Start Session",
  ibr: "Initiate BootstrapSession Request",
  htc: "Handle TsConfig",
  pss: "Prepare StartSession",
  bps: "Bootstrap POST Request Sent",
  lcss: "Load Css",
  boi: "BootstrapSession OnIntial Callbak",
  boe: "BootstrapSession OnError Callback",
  bos: "BootstrapSession OnSecondaryAction Callback",
  ntb: "Notified Bootstrap OnInitial Callback",
  nte: "Notified Bootatrap OnError Callback",
  propri: "Process Primary Payload",
  mdlini: "Model Initialization",
  mdlevt: "Model Event Handler",
  prosec: "Process Secondary Payload",
  pld: "ProgressiveLoad",
  uz: "Update Zones With Viz Data",
  pmu: "Process Model Update",
  clntld: "Client Fully Loaded",
  imgld: "Image Tiles Loaded",
  rmld: "Registered Modules Loaded",
  appstr: "Application Startup",
  appint: "Application Interactive",
  apppnt: "First Paint In Authoring",
  mdload: "Load Module Async",
  exerem: "Execute Remote Command",
  prorem: "Process Remote Command Response",
  exeerr: "Execute Remote Command With Error",
  exeloc: "Execute Local Command",
  proloc: "Process Local Command Response",
  plo: "Post Load Operation",
  gsi: "Get Session Info",
  gse: "Get Session Info With Error Retured",
  gas: "Get Acceleration State For View",
  rtload: "Runtime Load",
  df: "Download Font",
  tbrlay: "Toolbar Layout",
  tbrhnt: "Toolbar Handle New Toolbar",
  tbradd: "Add a Toolbar",
  tbrhre: "Toolbar Handle Resize",
  rtconv: "Runtime Model Presmodel Conversion",
};

// Get user friendly name of a MetricsEvent
export function getFriendlyEventDescription(desc: string): string | undefined {
  if (desc !== null && desc !== undefined) {
    return fullMetricsNameLookup[desc.split(uniqueKeySeparator)[0]];
  } else {
    return undefined;
  }
}

export { MetricsEvent };
